import { Col, Flex, Row, Typography } from '@duxton-web/ui';
import { TickMarkOutlined } from '@duxton-web/icons';
import {
  colorBackgroundAlt,
  colorContentPlaceholder,
  colorStatusPositiveDefault,
} from '@duxton-web/design-tokens/themes/light';
import React from 'react';

const UCDProjectCodeLabel = ({ code }) => {
  return (
    <Row gutter={24}>
      <Col span={24}>
        <Typography.Metadata level={2} color={colorContentPlaceholder}>
          Project code (Generated)
        </Typography.Metadata>
        <Flex
          align="center"
          justify="space-between"
          style={{
            marginTop: 10,
            backgroundColor: colorBackgroundAlt,
            padding: 14,
            borderRadius: 4,
          }}
        >
          <Typography.Paragraph level={2}>{code}</Typography.Paragraph>
          <TickMarkOutlined
            style={{
              fontSize: 20,
              color: colorStatusPositiveDefault,
            }}
          />
        </Flex>
      </Col>
    </Row>
  );
};

export default UCDProjectCodeLabel;
